import { observer } from 'mobx-react-lite'
import { useRef } from 'react'
import { Alert, SpinnerLoader } from 'shared/ui'
import { FiltersAndSearch } from 'widgets/FiltersAndSearch'
import { useAutomationLogsContext } from 'pages/settings/pages/integrations/context/automationLogsContext'
import { AutomationLogsEmptyState } from '../AutomationLogsEmptyState/AutomationLogsEmptyState'
import { AutomationLogsTable } from '../AutomationLogsTable/AutomationLogsTable'

import styles from './styles.module.scss'

export const AutomationLogsContent = observer(() => {
  const {
    canCloseAlert,
    showAlert,
    closeAlert,
    listStore: { filtersAndSearchStore, hasItems, loading },
  } = useAutomationLogsContext()

  const ref = useRef<HTMLDivElement | null>(null)

  const AlertComponent = showAlert ? (
    <Alert
      className={styles.alert}
      item={{
        type: 'infoBlue',
        desc: 'Shows “Send Message” logs from HubSpot Workflows. More sources and actions coming soon.',
      }}
      onClose={
        canCloseAlert && !loading && (filtersAndSearchStore.hasSearchParams || hasItems)
          ? closeAlert
          : undefined
      }
    />
  ) : null

  if (loading && !filtersAndSearchStore.hasSearchParams) {
    return (
      <div className={styles.container}>
        <SpinnerLoader ariaLabel={'AutomationLogsContent'} />
      </div>
    )
  }

  if (filtersAndSearchStore.hasSearchParams || hasItems)
    return (
      <div className={styles.container} ref={ref}>
        {AlertComponent}
        <FiltersAndSearch store={filtersAndSearchStore} parent={ref.current} />
        <AutomationLogsTable />
      </div>
    )

  return (
    <div className={styles.container}>
      {AlertComponent}
      <AutomationLogsEmptyState />
    </div>
  )
})
